let lastName = "";
let lastProduct = "";

const products = [
  {
    name: "Massageador Smart ThermaRelief Pro",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/serene-26-ceac914887092db8ef17346490884846-1024-1024_1.webp?v=1738278006"
  },
  {
    name: "Mini Processador De Alimentos Elétrico",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/a4d53c8b46b84d00462ef16c956a8b44.jpg?v=1742078809"
  },
  {
    name: "Lixador de Unhas Elétrico",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/CopiadeBRINCARZI_5_fad46905-390e-42ef-a52c-4b13a6be1ae0.png?v=1742174370"
  },
  {
    name: "Tampa Para Pernas de Móveis",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_4_Protetores_De_Pernas_De_Cadeira_Em_Silicone_4_Pares_Decoracao_De_Casa.webp?v=1742481710"
  },
  {
    name: "Aparador íntimo para homens",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_0_Cremalheira_Eletrica_Para_Depilacao_Corporal_E_Genital_Masculino_E_Feminino_9.webp?v=1742592025"
  },
  {
    name: "Anel Smart Ring",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_0.webp?v=1742569116"
  },
  {
    name: "Sandália AcuPoint",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/Seb6db2f5d03b40ebbbca281bae9cf7bfI.webp?v=1743540207"
  },
  {
    name: "Incensário Cascata",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main-image-4_9bff79ec-bb2b-4f1c-9260-78d8502b658a.jpg?v=1743540183"
  },
  {
    name: "Escova de Limpeza Elétrica 5 em 1",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/Se9852eb3f78045f69f401dd7690e7adaC.webp?v=1743540160"
  },
  {
    name: "Tapete para Banheiro Antiderrapante",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/D3AC0CEB-E59B-4601-8BED-A4E337F5C4F9.webp?v=1743540143"
  },
  {
    name: "Abridor Prático Triangular",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/H1042973e7b2a4b329140e9c47bc6cb3dk.jpg?v=1742824980"
  },
  {
    name: "Sapato Tecnológico Terra Max",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/40.jpg?v=1742510745"
  },
  {
    name: "Mini Barbeador Elétrico Portátil",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/Afd274b629d3c448f9a0c0d0c05d00ef9K.webp?v=1742826646"
  },
  {
    name: "Sandália Respirável Confort+",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/CAPAPRODUTOsandalia.png?v=1742734554"
  },
  {
    name: "Kit 2 Escovas de Cuidado Bucal para Bebês",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/CAPAproduto_407a419d-5ca8-4689-9873-393e70d2296a.png?v=1742744514"
  },
  {
    name: "Purificador de Ar com Filtro HEPA",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/converted_image.jpg?v=1742785632"
  },
  {
    name: "HeightMax Pro – Palmilha de Aumento de Altura",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/Scdd956ef0f234fe68f8dd07f6ca27056h.webp?v=1742943041"
  },
  {
    name: "Carpete Protetor para Sofás e Móveis",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/carpete_600x_dc908fc2-5b0b-4334-854c-de8497f17619.jpg?v=1743029687"
  },
  {
    name: "Pegador Multiuso de Panela",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_6_ac214172-2dcb-4ecc-9b23-5aed371558c8.webp?v=1743984397"
  },
  {
    name: "Kit de Forma de Ovo (5 Unidades)",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_3_82aa7537-a28b-496f-a8bd-24ef41f7ccbf.webp?v=1744027699"
  },
  {
    name: "Chinelo Ortopédico Top Comfort",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_2_Slipresistentes_OtimasParaVerao_Homens_DeemUmaChance.webp?v=1744028999"
  },
  {
    name: "Almofada Terapêutica para Pés - Diva Confort",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/5_a9c5140d-89ae-4061-afc5-8054fded890a.jpg?v=1744251263"
  },
  {
    name: "Open Egg – Abridor de Ovos 2 em 1",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/S74b61b8268e045c782fd3f085e6e600dQ.webp?v=1744380215"
  },
  {
    name: "Organizador Titan Max com Tampa",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/5_18b64948-db85-40da-a214-d3c1e15559be.png?v=1744503627"
  },
  {
    name: "Sandália Anatômica Pé de Algodão",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_13.webp?v=1744546727"
  },
  {
    name: "Pica Tudo Inox",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/br-11134207-7r98o-lpmbpeoghi0cad.webp?v=1744593119"
  },
  {
    name: "Forma de gelo com caixa de armazenamento",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/lilas.webp?v=1744724961"
  },
  {
    name: "HidroMax Sempre Verde",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/main_3_a6282169-f6d4-47cf-a54a-6bec95989472.webp?v=1744746051"
  },
  {
    name: "Amaciador de Carne Prático",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/br-11134207-7qukw-lk86yemzzui9c9.webp?v=1744748094"
  },
  {
    name: "Apoio Pro – Confiança no Banho",
    image: "https://cdn.shopify.com/s/files/1/0921/7042/0533/files/br-11134207-7r98o-lygie3r18zxhe7.webp?v=1744763358"
  } ];

const names = ["Paulo", "Samuel", "Fabiana", "Beatriz", "Tais", "Yan", "Rogério", "Adão", "Priscila", "Lara", "Clara", "Ana", "Angelo"];
const cities = ["São Paulo", "Rio de Janeiro", "Curitiba", "Belo Horizonte", "Fortaleza", "Salvador", "Goiânia", "Manaus", "Recife", "Porto Alegre"];
const emojis = ["🛍️", "🔥", "✅", "📦", "💥", "🧢", "👟", "🎯", "✨", "😎", "📢"];

function getRandomItem(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function generateRandomName() {
  return `${getRandomItem(names)} de ${getRandomItem(cities)}`;
}

// Pré-carrega imagens para evitar atraso
products.forEach(product => {
  const img = new Image();
  img.src = product.image;
});

function showSalePopUp() {
  let randomName, randomProduct;

  do {
    randomName = generateRandomName();
  } while (randomName === lastName);

  do {
    randomProduct = getRandomItem(products);
  } while (randomProduct.name === lastProduct);

  lastName = randomName;
  lastProduct = randomProduct.name;

  const emoji = getRandomItem(emojis);

  const popup = document.createElement("div");
  popup.className = "sales-popup";
  popup.innerHTML = `
    <img src="${randomProduct.image}" alt="${randomProduct.name}" class="popup-img" loading="lazy">
    <div class="popup-text">${emoji} <strong>${randomName}</strong> comprou <strong>${randomProduct.name}</strong></div>
  `;

  document.body.appendChild(popup);

  if (!document.getElementById("sales-popup-style")) {
    const style = document.createElement("style");
    style.id = "sales-popup-style";
    style.innerHTML = `
      .sales-popup {
        display: flex;
        align-items: center;
        gap: 10px;
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #ffffff;
        color: #0078ff;
        padding: 12px 16px;
        border-radius: 12px;
        font-size: 15px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
        z-index: 9999;
        animation: fadeInRight 0.4s ease-out;
        max-width: 320px;
        border: 1px solid #e0e0e0;
      }

      .sales-popup strong {
        font-weight: 600;
      }

      .sales-popup .popup-img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 8px;
      }

      .sales-popup .popup-text {
        flex: 1;
        line-height: 1.4;
      }

      @keyframes fadeInRight {
        from {
          opacity: 0;
          transform: translateX(20px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    `;
    document.head.appendChild(style);
  }

  setTimeout(() => popup.remove(), 5000);
}

showSalePopUp();
setInterval(showSalePopUp, 30000);
